import { isNil } from 'ramda';
import { orderToken } from './routers';
const getOrderParams = () => isNil(orderToken) ? {} : {
  order_token: orderToken
};
export const orderParams = getOrderParams();
export const isDefaultAccountSpa = isNil(orderToken);